import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import api from '../../services/api';
import styles from './Register.module.css';

function Register() {
  const [form, setForm] = useState({
    email: '',
    first_name: '',
    last_name: '',
    password: '',
    password_confirm: '',
  });
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  function handleChange(e) {
    setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');

    if (form.password !== form.password_confirm) {
      setError('Passwords do not match.');
      return;
    }

    if (form.password.length < 8) {
      setError('Password must be at least 8 characters.');
      return;
    }

    setSubmitting(true);

    try {
      const res = await api.post('/auth/register/', {
        email: form.email,
        username: form.email.split('@')[0],
        first_name: form.first_name,
        last_name: form.last_name,
        password: form.password,
        password_confirm: form.password_confirm,
      });

      if (res.data.success) {
        const tokens = res.data.data.tokens;
        localStorage.setItem('access_token', tokens.access);
        localStorage.setItem('refresh_token', tokens.refresh);
        // Fetch user to populate context
        await login(form.email, form.password);
        navigate('/dashboard');
      }
    } catch (err) {
      const msg = err.response?.data?.message || 'Registration failed.';
      const errors = err.response?.data?.errors;
      if (errors) {
        const firstError = Object.values(errors).flat()[0];
        setError(typeof firstError === 'string' ? firstError : msg);
      } else {
        setError(msg);
      }
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <h1 className={styles.title}>Trucount</h1>
        <p className={styles.tagline}>Create your account</p>

        <form onSubmit={handleSubmit} className={styles.form}>
          {error && <div className={styles.error}>{error}</div>}

          <div className={styles.nameRow}>
            <label className={styles.label}>
              First Name
              <input
                type="text"
                name="first_name"
                value={form.first_name}
                onChange={handleChange}
                className={styles.input}
                required
                autoFocus
              />
            </label>
            <label className={styles.label}>
              Last Name
              <input
                type="text"
                name="last_name"
                value={form.last_name}
                onChange={handleChange}
                className={styles.input}
                required
              />
            </label>
          </div>

          <label className={styles.label}>
            Email
            <input
              type="email"
              name="email"
              value={form.email}
              onChange={handleChange}
              className={styles.input}
              required
            />
          </label>

          <label className={styles.label}>
            Password
            <input
              type="password"
              name="password"
              value={form.password}
              onChange={handleChange}
              className={styles.input}
              required
              minLength={8}
            />
          </label>

          <label className={styles.label}>
            Confirm Password
            <input
              type="password"
              name="password_confirm"
              value={form.password_confirm}
              onChange={handleChange}
              className={styles.input}
              required
            />
          </label>

          <button type="submit" className={styles.button} disabled={submitting}>
            {submitting ? 'Creating account...' : 'Create Account'}
          </button>

          <p style={{ textAlign: 'center', fontSize: 14, color: '#6b7280', marginTop: 4 }}>
            Already have an account?{' '}
            <Link to="/login" style={{ color: '#2563eb', fontWeight: 500 }}>Sign in</Link>
          </p>
        </form>
      </div>
    </div>
  );
}

export default Register;
